if($('body').hasClass('homepage')){
    $(window).scroll(function() {
        let scrollTop = $(window).scrollTop();
        let desktop_navbar = $('.desktop-navbar');
        if(scrollTop > 400){
            desktop_navbar.addClass('visible');
            // desktop_navbar.css('top', 0);
        }else{
            desktop_navbar.removeClass('visible');
            // wait 0.2s
            // desktop_navbar.css('top', 0);
        }
    })
}

$(document).ready(function(){

    let hp_banner_video = $('.hp-banner-video');

    if(hp_banner_video.length) {
        if ($(window).width() < 768) {
            hp_banner_video.get(1).play();
        } else {
            hp_banner_video.get(0).play();
        }
    }

    $('.js-hp-video-pause').click(function(){
        if ($(window).width() < 768) {
            $('.hp-banner-video').get(1).pause();
        }else{
            $('.hp-banner-video').get(0).pause();
        }
    })

    $('.js-hp-video-play').click(function(){
        if ($(window).width() < 768) {
            $('.hp-banner-video').get(1).play();
        }else{
            $('.hp-banner-video').get(0).play();
        }
    })
})
